import { RemarkButton } from '@Components/IconButton';
import Remark from '@Components/Remark';
import { useDisclosure } from '@hooks/useDisclosure';
import { Box } from '@mui/material';
import { createPortal } from 'react-dom';
import { useWatch } from 'react-hook-form';
import { useGreenhouseForm } from '../EsgGreenhouseFormProvider';
import { IClimateChangeStructureFormValues } from '../EsgGreenhouseFormProvider/types';

export const CLIMATE_CHANGE_STRUCTURE_REMARK_ID =
  'climate-change-structure-remark';

const ClimateChangeStructureRemark = () => {
  const { control, getValues } = useGreenhouseForm();
  const { remark } =
    getValues(`climateChangeStructure`) ??
    ({} as IClimateChangeStructureFormValues);

  const [isRemarkOpen, { open, close }] = useDisclosure(!!remark);

  const climateChangeStructureRemarkEl = document.getElementById(
    CLIMATE_CHANGE_STRUCTURE_REMARK_ID
  );

  const { completedSection } =
    useWatch({
      name: 'climateChangeStructure',
      control,
    }) ?? ({} as IClimateChangeStructureFormValues);

  const { isCompletedTh = false, isCompletedEn = false } =
    completedSection ?? {};

  return (
    <>
      <RemarkButton onClick={open} disabled={isCompletedTh && isCompletedEn} />
      {isRemarkOpen &&
        climateChangeStructureRemarkEl &&
        createPortal(
          <Box mt={2}>
            <Remark
              onDelete={close}
              topic="กำหนดโครงสร้างการกำกับดูแลด้านการเปลี่ยนแปลงสภาพภูมิอากาศ"
              setOpen={open}
              fieldPath="climateChangeStructure.remark"
              isCompletedEn={isCompletedEn}
              isCompletedTh={isCompletedTh}
            />
          </Box>,
          climateChangeStructureRemarkEl
        )}
    </>
  );
};

export default ClimateChangeStructureRemark;
